export const iconCss = {
  path: {
    fill: "currentColor",
  },
};
